import { render, staticRenderFns } from "./ImpostoSemResultado.vue?vue&type=template&id=76726a4d&scoped=true&"
import script from "./ImpostoSemResultado.vue?vue&type=script&lang=js&"
export * from "./ImpostoSemResultado.vue?vue&type=script&lang=js&"
import style0 from "./ImpostoSemResultado.vue?vue&type=style&index=0&id=76726a4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76726a4d",
  null
  
)

export default component.exports